import {
  FETCH_PARKING_CHARGES_BY_PERMIT_TYPE_REQUEST,
  FETCH_PARKING_CHARGES_BY_PERMIT_TYPE_SUCCESS,
  FETCH_PARKING_CHARGES_BY_PERMIT_TYPE_FAILURE,
} from './types';

const initialState = {
  chargesByPermitType: [],
  loading: false,
  error: null,
};

const parkingChargesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PARKING_CHARGES_BY_PERMIT_TYPE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PARKING_CHARGES_BY_PERMIT_TYPE_SUCCESS:
      return { ...state, loading: false, chargesByPermitType: action.payload || [] };
    case FETCH_PARKING_CHARGES_BY_PERMIT_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default parkingChargesReducer;
